import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { uploadPaymentsDataEvent } from '../../../_events/payments/upload_payments.event';
import { message } from "antd";
import PaymentsInfo from './payments_info';
import UploadFile from '../../../containers/upload_file/upload_file';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Chip from '@mui/material/Chip';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import PrimaryProgress from '../../../containers/progress/primary_progress';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import RolWrapper from "../../hoc/roles_wrapper";
import { ROLES } from "../../../_config/roles";

const ButtonRolAuthComponent = RolWrapper(Button, [ROLES.root, ROLES.accounter, ROLES.admin]);

const Payments = () => {

    const [render, setRender] = useState('info');
    const [lastUpdate, setLasUpdate] = useState('Sin datos');

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
                    <Typography variant="h6" component="h6">
                        Pagos
                    </Typography>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width:'100%'}}>
                        <Chip color="primary" style={{marginRight: '20px'}} icon={<UploadFileIcon />} label={`Última actualización: ${lastUpdate}`} variant="outlined" />
                        {
                            render === 'info' ? 
                            <ButtonRolAuthComponent onClick={() => {setRender('form');}} variant="contained">Actualizar</ButtonRolAuthComponent>
                            :
                            <Button onClick={() => setRender('info')} variant="contained">Ver listado</Button>
                        }
                    </div>
                </div>
                <hr />
                <div style={{overflowY: 'auto'}}>
                    {
                        render === 'info' ? <PaymentsInfo setLastUpdate={(date) => setLasUpdate(date)} /> : <PaymentsForm setLastUpdate={() => setLasUpdate('Hoy hace 1 segundo')} />
                    } 
                </div>               
            </Grid>
        </Grid>
    );
}

const PaymentsForm = (props) => {

    const [dataUpload, setDataUpload] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [dateCreated, setDateCreated] = useState(new Date());

    const buildExcelBytes = (e, onSuccess) => {
        let extension = '.';
        e.preventDefault()
        const reader = new FileReader()
        reader.onload = async (e) => { 
            let bytes_file = (e.target.result);
            onSuccess(bytes_file, extension);
        };
        if(e.target.files.length > 0){
            extension = e.target.files[0].name.split('.')[1];
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    const uploadData = (bytes, extension, type) => {
        setLoadingData(true);
        uploadPaymentsDataEvent(bytes, extension, type, dateCreated)
        .then(data => {
            setDataUpload(data);
            setLoadingData(false);
            props.setLastUpdate();
        })
        .catch(err => {
            message.error(err.message);
            setLoadingData(false);
        });
    }

    return(
        <div style={{width: '100%'}}>
            <Grid container spacing={1}>
            <Grid item xs={6} md={6}>
                    <div style={{marginTop: '10px'}}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileDatePicker
                                label="Fecha de actualización"
                                inputFormat="yyyy-MM-dd"
                                value={dateCreated}
                                onChange={(value) => {
                                    setDateCreated(value);
                                }}
                                renderInput={(params) => <TextField size="small" {...params} />}
                            />
                        </LocalizationProvider>
                    </div>            
                </Grid>
                <Grid item xs={6} md={6}>
                    <UploadFile
                        readFile={
                            (e) => buildExcelBytes(e, 
                                (bytes, ext) => uploadData(bytes, ext, 'pb')
                            )
                        }
                    />
                </Grid>
                <Grid item xs={12} md={12}>
                    {
                        loadingData ? (
                            <PrimaryProgress />
                        ) : (
                            <Alert severity="info">
                                <AlertTitle>Datos cargados:</AlertTitle>
                                <span>{dataUpload.length}</span>
                            </Alert>
                            
                        )
                    }
                </Grid>               
            </Grid>
        </div>
    );
}

export default Payments;